import type { MatchFilters } from "./matchFiltersSchema";

// Включён ли хоть один фильтр. Пустой список героев — фильтра по героям нет.
export const hasFilters = ({ heroes = [], ...others }: MatchFilters): boolean =>
  heroes.length > 0 || Object.values<unknown>(others).some((value) => value !== undefined);
